import React from 'react';
import { scrollToElement } from '../utils/scrollToElement';
/**
 * Editorial 2-column hero (desktop) / single-column (mobile) — the pattern
 * used by the highest-converting Spanish-language wellness/info-product
 * landing pages.
 *
 *  - LEFT:  eyebrow → big serif headline w/ italic emphasis → subhead line
 *           → body paragraph → primary CTA + secondary text link.
 *  - RIGHT: lifestyle photo of the woman the reader wants to become,
 *           framed with the soft sage/cream editorial treatment.
 *
 * Mobile keeps the text first so the H1 paints early and remains the LCP
 * element; the image drops below the copy.
 */
export function Hero() {
  return <section className="relative pt-24 md:pt-28 pb-12 md:pb-20 overflow-hidden bg-cream" data-id="element-129">
      <div className="max-w-6xl mx-auto px-6 md:px-12 w-full grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center" data-id="element-130">
        {/* TEXT — left on desktop, first on mobile */}
        <div className="flex flex-col items-start text-left lg:col-span-7 order-1" data-id="element-131">
          <span className="uppercase tracking-[0.22em] text-[11px] md:text-xs font-medium text-sand-dark mb-5" data-id="element-132">
            Un nuevo capítulo en el bienestar femenino
          </span>

          <h1 className="font-serif text-[2.5rem] sm:text-5xl md:text-6xl lg:text-[4.25rem] leading-[1.05] text-ink mb-5 md:mb-6" data-id="element-133">
            Recupera tu{' '}
            <em className="italic text-sand-dark font-normal" data-id="element-134">energía</em>,
            balance y{' '}
            <em className="italic text-sand-dark font-normal" data-id="element-135">claridad</em>.
          </h1>

          <p className="font-serif text-lg md:text-xl text-ink-light italic mb-5 md:mb-6 leading-snug" data-id="element-136">
            El método del 1% para volver a sentirte tú misma.
          </p>

          <p className="text-base md:text-lg text-ink-light font-light leading-relaxed mb-8 md:mb-10 max-w-lg" data-id="element-137">
            Una guía respaldada por la ciencia para equilibrar tus hormonas de
            forma natural — sin dietas extremas, sin suplementos costosos y sin
            agotamiento. Resultados visibles en tus primeros 30 días.
          </p>

          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5 sm:gap-6 w-full sm:w-auto" data-id="element-138">
            <button type="button" onClick={() => scrollToElement('precio')} className="inline-flex items-center justify-center bg-sand hover:bg-sand-dark text-white px-8 py-4 text-sm font-medium tracking-widest uppercase transition-colors duration-300 active:scale-[0.98] w-full sm:w-auto" data-id="element-139">
              Acceso Inmediato
            </button>
            <a href="#method" className="text-sm uppercase tracking-widest text-ink-light hover:text-ink transition-colors border-b border-transparent hover:border-ink pb-1 self-center" data-id="element-140">
              Descubre el Método
            </a>
          </div>
        </div>

        {/* IMAGE — right on desktop, below text on mobile */}
        <div className="relative w-full lg:col-span-5 order-2" data-id="element-141">
          <div className="relative mx-auto max-w-[160px] sm:max-w-[200px] lg:max-w-[220px]" data-id="element-142">
            {/* Soft sage card behind */}
            <div className="absolute -inset-3 md:-inset-4 bg-sage/40 rounded-2xl rotate-[-2deg]" data-id="element-143"></div>
            {/* Photo */}
            <div className="relative aspect-[4/5] overflow-hidden rounded-xl shadow-soft-lg bg-white" data-id="element-144">
              <img src="https://images.unsplash.com/photo-1545389336-cf090694435e?q=85&w=800&auto=format&fit=crop" srcSet="https://images.unsplash.com/photo-1545389336-cf090694435e?q=85&w=500&auto=format&fit=crop 500w, https://images.unsplash.com/photo-1545389336-cf090694435e?q=85&w=800&auto=format&fit=crop 800w, https://images.unsplash.com/photo-1545389336-cf090694435e?q=85&w=1100&auto=format&fit=crop 1100w" sizes="(max-width: 640px) 160px, (max-width: 1024px) 200px, 220px" alt="Mujer serena en plena naturaleza, irradiando vitalidad y equilibrio hormonal" width={800} height={1000}
            // @ts-expect-error fetchpriority is valid HTML but typed loosely in React
            fetchpriority="high" loading="eager" decoding="async" className="w-full h-full object-cover object-center" data-id="element-145" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}